import React from "react";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import useQueryURL from "../../../common/hooks/useQueryURL";
import SingleConnector from "../../../features/stations/components/SingleConnector";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import useNavigationApp from "../../../navigation/useNavigationApp";
import { useSingleConnector } from "../../../features/stations/hooks/useConnectors";
import ButtonSmallIcon from "../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import { SingleStation } from "../../../features/stations/components/SingleStation";
import SectionTitle, {
  Section,
} from "../../../common/components/atom/SectionTitle/SectionTitle";
import { JWayIcon } from "../../../common/assets/JWayIcons";

export const SINGLE_CONNECTOR_MODAL_ID = "single-connector-modal";

export default function SingleConnectorPage() {
  const navigate = useNavigationApp();
  const { connectorIdFound } = useSingleConnector({});
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <ButtonSmallIcon
          iconType={"edit-sheet"}
          label="Modifier"
          variant="stack"
          onClick={() => {
            navigate.goToEditConnector({
              connectorId: connectorIdFound,
              relatifPath: true,
            });
          }}
        />
      </div>
      <div
        style={{
          height: "200px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Slug de la Station",
              TextRender: () => <SingleConnector.Info info="station_slug" />,
            },

            {
              title: "Slug d'identification",
              TextRender: () => (
                <>
                  <SingleConnector.Info info="b_connector_slug" />
                </>
              ),
            },
            {
              title: "Puissance max",
              TextRender: () => (
                <>
                  <SingleConnector.Info info="b_connector_max_power_kw" />
                  <span>KW</span>
                </>
              ),
            },
          ]}
        />
        <TextBox
          content={[
            {
              title: "Créer le",
              TextRender: () => (
                <>
                  <SingleConnector.Info info="b_connector_created_at" />
                </>
              ),
            },
            {
              title: "Type de connecteur",
              TextRender: () => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <SingleConnector.Info info="b_connector_type" />
                  <div style={{ height: "5px" }} />
                  <SingleConnector.Info
                    info="connector_icon"
                    size={40}
                    color="#00000050"
                  />
                </div>
              ),
            },
          ]}
        />
      </div>

      <div
        style={{
          height: "80px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Tag",
              TextRender: () => (
                <>
                  <SingleConnector.Info info="b_connector_tag_id" />
                </>
              ),
            },
          ]}
        />

        <TextBox
          content={[
            {
              title: "Prix par kWh",
              TextRender: () => (
                <>
                  <SingleConnector.Info info="b_connector_price_per_kwh" />
                  <span>
                    <SingleConnector.Info info="b_connector_price_currency" />
                  </span>
                </>
              ),
            },
          ]}
        />
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      ></div>

      <div style={{ height: "auto", gap: "20px", display: "flex" }}>
        <TextBox
          content={[
            {
              title: "QRCode",
              TextRender: () => (
                <div style={{ width: "100px", height: "150px" }}>
                  <SingleConnector.QRCode style={{ height: "100%" }} />
                </div>
              ),
            },
          ]}
        />
      </div>
      <div style={{ height: "50px" }} />

      <Section
        topGap={-20}
        stickyHeaderRender={() => (
          <div
            style={{
              height: "40px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <SectionTitle iconType="info" iconSize={8}>
              Statistiques
            </SectionTitle>{" "}
            <SingleStation.Charts.FilterTimeWindowBtn />
          </div>
        )}
      >
        <div
          style={{
            height: "auto",
            gap: "20px",
            display: "flex",
            marginTop: "20px",
          }}
        >
          <TextBox
            content={[
              {
                title: "Energie consommée",
                isDrawable: true,

                LeftIconRender: () => (
                  <JWayIcon type="chart-in-box" size={14} color="gray" />
                ),
                TextRender: () => (
                  <div style={{ width: "100%", height: "250px" }}>
                    <SingleConnector.Analysis.GenericChart
                      measurand="Energy.Active.Import.Register"
                      unit="kWh"
                      convert={(v) => Number((v * 0.001).toFixed(2))}
                      chartType="bar"
                    />
                  </div>
                ),
              },
            ]}
          />
        </div>

        <div
          style={{
            height: "auto",
            gap: "20px",
            display: "flex",
            marginTop: "20px",
          }}
        >
          <TextBox
            content={[
              {
                title: "Puissance active",
                isDrawable: true,

                LeftIconRender: () => (
                  <JWayIcon type="chart-in-box" size={14} color="gray" />
                ),
                TextRender: () => (
                  <div style={{ width: "100%", height: "250px" }}>
                    <SingleConnector.Analysis.GenericChart
                      measurand="Power.Active.Import"
                      unit="kW"
                      convert={(v) => Number((v * 0.001).toFixed(2))}
                      chartType="line"
                    />
                  </div>
                ),
              },
            ]}
          />
        </div>

        <div
          style={{
            height: "auto",
            gap: "20px",
            display: "flex",
            marginTop: "20px",
          }}
        >
          <TextBox
            content={[
              {
                title: "Facteur de puissance",
                isDrawable: true,

                LeftIconRender: () => (
                  <JWayIcon type="chart-in-box" size={14} color="gray" />
                ),
                TextRender: () => (
                  <div style={{ width: "100%", height: "250px" }}>
                    <SingleConnector.Analysis.GenericChart
                      measurand="Power.Factor"
                      unit="kW"
                      convert={(v) => Number((v * 0.001).toFixed(2))}
                      chartType="line"
                    />
                  </div>
                ),
              },
            ]}
          />
        </div>

        <div
          style={{
            height: "auto",
            gap: "20px",
            display: "flex",
            marginTop: "20px",
          }}
        >
          <TextBox
            content={[
              {
                title: "Voltage",
                isDrawable: true,

                LeftIconRender: () => (
                  <JWayIcon type="chart-in-box" size={14} color="gray" />
                ),
                TextRender: () => (
                  <div style={{ width: "100%", height: "250px" }}>
                    <SingleConnector.Analysis.GenericChart
                      measurand="Voltage"
                      unit="V"
                      convert={(v) => Number((v*.001).toFixed(2))}
                      chartType="line"
                    />
                  </div>
                ),
              },
            ]}
          />
        </div>
        <div
          style={{
            height: "auto",
            gap: "20px",
            display: "flex",
            marginTop: "20px",
          }}
        >
          <TextBox
            content={[
              {
                title: "Température",
                isDrawable: true,

                LeftIconRender: () => (
                  <JWayIcon type="chart-in-box" size={14} color="gray" />
                ),
                TextRender: () => (
                  <div style={{ width: "100%", height: "250px" }}>
                    <SingleConnector.Analysis.GenericChart
                      measurand="Temperature"
                      unit="C"
                      convert={(v) => Number(v.toFixed(2))}
                      chartType="line"
                    />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </Section>
      <div style={{ height: "80px" }} />
    </div>
  );
}

export const SingleConnectorModal = ({
  modalId,
  zIndex,
}: {
  modalId?: string;
  zIndex?: number;
}) => {
  const modalIdFound = modalId || SINGLE_CONNECTOR_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue([modalIdFound]);
  };
  return (
    <ModalDrawer
      urlParamName={modalIdFound}
      zIndex={zIndex}
      titleRender={
        <>
          Connecteur <SingleConnector.Info info="b_connector_slug" />{" "}
        </>
      }
      onClose={onClose}
    >
      <SingleConnectorPage />
    </ModalDrawer>
  );
};
